import { StyledAnchors } from '@/components/styles';
import { ActiveLink } from '@/components';
import Swiper from 'react-id-swiper';
import genLinkParams from '@/lib/generateLinkParams';

export default function Anchors({
  list = [],
  handleClick,
  active,
  slider,
  params,
  activeThumb,
  type,
  arrow = 'right',
  remountKey,
  asPageLinks = false,
}) {
  return (
    <StyledAnchors type={type}>
      {slider ? (
        <Swiper key={remountKey} {...params} shouldSwiperUpdate>
          {list.map((item, ind) => {
            const { title, id } = item;
            const onClick = () => {
              handleClick && handleClick(ind);
            };
            return (
              <StyledAnchors.Item key={id} as="p" id={`anchor-${id}`}>
                <StyledAnchors.Link onClick={onClick} as="span" active={activeThumb === ind}>
                  {title}
                </StyledAnchors.Link>
              </StyledAnchors.Item>
            );
          })}
        </Swiper>
      ) : (
        <>
          {list.map((item) => {
            const { title, id, slug } = item;
            const [pageHref, pageAs] =
              asPageLinks && slug ? genLinkParams({ type: 'subdirection', slug }) : [];

            const onClick = (e) => {
              if (pageAs) {
                return;
              }

              e.preventDefault();
              if (slug) {
                handleClick && handleClick(slug);
              } else {
                handleClick && handleClick(id);
              }
            };

            const link = (
              <StyledAnchors.Link
                href={pageAs || `#${id}`}
                onClick={onClick}
                isActive={active == slug}
                arrow={arrow}
              >
                {title}
              </StyledAnchors.Link>
            );

            return (
              <StyledAnchors.Item key={id}>
                {pageHref && pageAs ? (
                  <ActiveLink href={pageHref} as={pageAs} addHrefActive={true} activeAs="a">
                    {link}
                  </ActiveLink>
                ) : (
                  link
                )}
              </StyledAnchors.Item>
            );
          })}
        </>
      )}
    </StyledAnchors>
  );
}
